import * as React from "react"
const OnDemandIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M8 21h6c5 0 7-2 7-7V8c0-5-2-7-7-7H8C3 1 1 3 1 8v6c0 5 2 7 7 7Z"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M8.1 9.52c0-1.91 1.35-2.68 3-1.73l2.56 1.48c1.65.95 1.65 2.51 0 3.46l-2.56 1.48c-1.65.95-3 .17-3-1.73V9.52Z"
    />
  </svg>
)
export default OnDemandIcon
